var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571",
    transform: "translate(-28 -271)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(28 271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search_4_",
    "data-name": "search (4)",
    transform: "translate(36 279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M3.724,143.885l-.585,2.184L1,146.113a8.416,8.416,0,0,1-.062-7.845h0l1.9.349.834,1.892a5.014,5.014,0,0,0,.047,3.376Z",
    transform: "translate(0 -133.73)",
    fill: "#fbbb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M269.7,208.176a8.4,8.4,0,0,1-3,8.122h0l-2.4-.122-.339-2.118a5.007,5.007,0,0,0,2.154-2.557h-4.493v-3.324h8.07Z",
    transform: "translate(-253.042 -201.344)",
    fill: "#518ef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M43.169,314.208h0a8.4,8.4,0,0,1-12.66-2.57l2.723-2.229a5,5,0,0,0,7.2,2.558Z",
    transform: "translate(-29.508 -299.254)",
    fill: "#28b446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M41.449,1.934,38.727,4.163a5,5,0,0,0-7.366,2.616L28.624,4.538h0a8.4,8.4,0,0,1,12.825-2.6Z",
    transform: "translate(-27.685)",
    fill: "#f14336"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.73d718a0.svg";
export { ForwardRef as ReactComponent };